import React from 'react';

import './styles.css';

export default function MainPromo() {
  return (
    <div className="mainPromoContent"><img src="https://cazvid.com/images/cazvid-get-started.png" alt="CazVid Get Started" /></div>
  );
};